import React from 'react';

const CircularLoader = () => (
  <div id="loader-wrapper">
    <div className="main-loader">
      <div className="loader">
        <svg className="circular-loader" viewBox="25 25 50 50">
          <circle
            className="loader-path"
            cx={50}
            cy={50}
            r={20}
            fill="none"
            stroke="#01D66C"
            strokeWidth={2}
          />
        </svg>
      </div>
    </div>
  </div>
);

export default CircularLoader;
